import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";
import { IJobsProps } from "../types";

export const QUERY_KEY_FOR_SINGLE_JOB = "single-job";

const getSingleData = async (props: IGeneralProps): Promise<IJobsProps> => {
  const id = props.id;
  const url = `${END_POINT.BASE_URL}/v1/job/${id}`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  const item = res.data.data;

  const data: IJobsProps = { ...item };

  return data;
};

export const useGetSingleJob = ({ id, token }: IGeneralProps) => {
  const queryData = useQuery(
    [QUERY_KEY_FOR_SINGLE_JOB, id],
    () =>
      getSingleData({
        id,
        token,
      }),
    {
      enabled: !!id,
    }
  );

  return queryData;
};


const fetchPublicSingleJob = async (id: string) => {
  const url = `${END_POINT.BASE_URL}/career-portal/${id}`;

  const response = await axios.get(url);
  return response.data?.data || response.data;
};

export const useGetPublicSingleJob = (id?: string) => {
  return useQuery(["publicSingleJob", id], () => fetchPublicSingleJob(id!), {
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
  });
};

